/**
 * Mock Einstein recommendations for sandbox testing.
 *
 * The Einstein API returns no real recommendations in the sandbox environment.
 * This constant provides placeholder product IDs so the Carousel renders during development.
 *
 * Only `id` (product ID) is required — full product details are fetched from SCAPI
 * via `useContentfulCarouselProducts` using these IDs.
 *
 * TO UPDATE: Replace the `id` values below with real King Living sandbox product IDs.
 *
 * TO DISABLE: Remove the mock fallback in carousel.jsx once the production Einstein
 * recommender is configured and returning live recommendations.
 */
export const MOCK_EINSTEIN_RECOMMENDATIONS = {
  recommenderName: 'mock-recommender',
  recoUUID: '87b6d8bf-0f86-4ccd-af89-fbda90114c30',
  recs: [
    {id: 'QUAY-TBL_2400_MAR_QY_DIN_PKG_GUIDED'},
    {id: 'J2-PKG-9-SMRT-RECOM'},
    {id: '1977-2STR_MODULE_V3'},
    {id: 'RUGKL-ANTIPODES_260_x_360'},
    {id: '1977-PKG_1'},
    {id: 'MYCO-SD_TBL_TIMB_490_LTH_GUIDED'},
    {id: 'ADELBD-4P_PKG_K_AU_V2_GUIDED------_Mosquito_Net'},
    {id: 'AURAO-SHADE_CANOPY_1900'}
  ],
};
